"use client";

import { useEffect, useRef, useState } from "react";

const GRID_SIZE = 64;
const directions = [
  { name: "horizontal", animation: "shootingStar-horizontal" },
  { name: "horizontal-reverse", animation: "shootingStar-horizontal-reverse" },
  { name: "vertical", animation: "shootingStar-vertical" },
  { name: "vertical-reverse", animation: "shootingStar-vertical-reverse" },
];

let starId = 0;

const ShootingStars = () => {
  const [stars, setStars] = useState<
    { id: number; x: number; y: number; dir: number; duration: number }[]
  >([]);
  const intervalRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const createStar = () => {
      const dir = Math.floor(Math.random() * directions.length);
      let x = 0,
        y = 0;
      if (dir < 2) {
        y = Math.floor(Math.random() * (window.innerHeight / GRID_SIZE)) * GRID_SIZE;
        x = dir === 0 ? 0 : window.innerWidth - 96;
      } else {
        x = Math.floor(Math.random() * (window.innerWidth / GRID_SIZE)) * GRID_SIZE;
        y = dir === 2 ? 0 : window.innerHeight - 96;
      }
      const duration = 2 + Math.random() * 1.2;
      const id = ++starId;
      setStars((prev) => [...prev, { id, x, y, dir, duration }]);
      setTimeout(() => {
        setStars((prev) => prev.filter((star) => star.id !== id));
      }, duration * 1000);
    };

    const loop = () => {
      createStar();
      intervalRef.current = setTimeout(loop, 900 + Math.random() * 1200);
    };
    loop();
    return () => {
      if (intervalRef.current) clearTimeout(intervalRef.current);
    };
  }, []);

  return (
    <>
      {stars.map((star) => {
        const d = directions[star.dir];
        return (
          <div
            key={star.id}
            className={`shooting-star ${d.name}`}
            style={{
              left: star.x,
              top: star.y,
              animation: `${d.animation} ${star.duration}s linear`,
            }}
          />
        );
      })}
    </>
  );
};

export default ShootingStars;
